import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/** Put all uiSchema options here, in the template they go under ui:options: */
export const ReadmePreviewFieldUiOptionsSchema = z.object({
  inputLabel: z
    .string()
    .optional()
    .describe('Label shown above the markdown input. Defaults to "Readme".'),
  previewLabel: z
    .string()
    .optional()
    .describe('Label shown above the preview panel. Defaults to "Preview".'),
  rows: z
    .number()
    .optional()
    .describe(
      'Number of visible rows of the input; it scrolls beyond that. Defaults to 10.',
    ),
  placeholder: z
    .string()
    .optional()
    .describe('Placeholder text for the markdown input.'),
});

/** Transforms the Zod schema to a TypeScript type */
export type ReadmePreviewFieldUiOptions = z.infer<
  typeof ReadmePreviewFieldUiOptionsSchema
>;

/** The field schema for the ReadmePreviewField field extension */
export const ReadmePreviewFieldFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('Markdown README content'),
  ReadmePreviewFieldUiOptionsSchema,
);

/** Transforms the field schema props to a TypeScript type */
export type ReadmePreviewFieldProps = typeof ReadmePreviewFieldFieldSchema.type;

/** The final schema used for the field extension */
export const ReadmePreviewFieldSchema = ReadmePreviewFieldFieldSchema.schema;
